import { Required, Schema } from "lego-gui-lib/lib";
import { mainStore, api } from "../../../core/mainStore";
import i18next from "i18next";
import { LanguageFK } from "../../language/schema";
import { RemoteChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteChildDataSource";
import { Auth } from "../../../core/model/auth";
import { EnumField } from "lego-gui-lib";
import { DigitsEnum } from "../../../common/common";
import { createContext } from "react";

// @ts-ignore
const t = (...args: unknown[]): string => () => i18next.t(...args);

export const LanguageSelectionChoiceSchema = new Schema({
  fields: [
    {
      name: "digit",
      title: t("common:digit"),
      type: EnumField(DigitsEnum, Required)
    },
    {
      name: "languageRef",
      title: t("hns:language:domain"),
      type: LanguageFK
    }
  ],
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ANYONE,
    editableRole: Auth.Roles.ANYONE_WITH_WRITE
  }
});

export const LanguageSelectionChoiceSchemaColumns = LanguageSelectionChoiceSchema.extend(
  {
    languageSelectRef: false
  }
);

mainStore.languageSelectionChoice = RemoteChildDataSource.create({
  parent: mainStore.languageSelection.oneDataSource,
  api: api,
  name: "languageSelectionChoice",
  schema: LanguageSelectionChoiceSchema,
  url: "/choices",
  commons: mainStore.commons
});

export const languageSelectionChoiceContext = createContext(
  mainStore.languageSelectionChoice
);
